
export default {
  label: 'label-override',
  group: 'form-group',
  displayWrapper: '',
  input: 'form-control',
};



// WEBPACK FOOTER //
// src/common/form-elements/guid-element-folder/guid-element.style.js